import store from 'store';
import { _MS_PER_DAY, dateDiffInDays, ParseSingleStringifiedStati } from '../Functions';
import fire from '../base';

export const defaultPreferences = {
  calcMethod: 1,
  theme: 'dark',
  format: '12'
}

export const signed = async (dispatch, creds, location) => {
  if (creds.additionalUserInfo.isNewUser) {
    let stati = [...(store.get("abandonedStati") || []).map(item => ParseSingleStringifiedStati(item)), ...(store.get("stati") || [])]; //see if stati is saved locally
    if (!stati || stati.length === 0) {
      stati = []; //initialise with default value if not available
      const temp = { Fajr: 'n', Zuhr: 'n', Asr: 'n', Maghrib: 'n', Isha: 'n' };
      const msRightNow = new Date().getTime();
      for (let i = 6; i >= 0; i--) {
        let date = new Date(msRightNow - i * _MS_PER_DAY);
        stati.push({ ...temp, timestamp: date.toISOString(), unixTimestamp: date.getTime() });
      }
    } else {
      stati.forEach(status => status.unixTimestamp = new Date(status.timestamp || status.date).getTime());
    }

    let preferences = store.get("preferences");
    if (!preferences) {
      preferences = { ...defaultPreferences }
    }
    preferences.location = location;

    const batch = fire.firestore().batch();
    const userRef = fire.firestore().collection('users').doc(creds.user.uid);
    stati.forEach(doc => {
      batch.set(userRef.collection('stati').doc(new Date(doc.unixTimestamp).toDateString()), doc);
    });
    batch.set(userRef, { preferences }, { merge: true });
    await batch.commit();
  }
}

// export const register = (dispatch, formState) => {
//   // formState.location = { city: formState.city, country: formState.country }
//   store.set("preferences", {
//     ...formState
//   });
//   store.set("hasInitialised", true);

//   const stati = [];
//   const temp = { Fajr: 'n', Zuhr: 'n', Asr: 'n', Maghrib: 'n', Isha: 'n' };
//   const msRightNow = new Date().getTime();
//   for (let i = 6; i >= 0; i--) {
//     stati.push({ ...temp, timestamp: new Date(msRightNow - i * _MS_PER_DAY).toISOString() });
//   }

//   store.set("stati", stati);
//   dispatch({ type: "INITIALISE_SUCCESS", "source": "reg.js", payload: { preferences: formState, stati } });
// }

// export const unregister = (dispatch) => {
//   dispatch({ type: "INITIALISE_UNDO" });
//   store.clearAll();
//   window.location.reload();
// }

// export const syncStatiDate = (dispatch, stati) => {
//   return;
//   const newStati = [...stati];
//   const timestamp = new Date();
//   const lastTimestamp = new Date(stati[stati.length - 1].timestamp || stati[stati.length - 1].date);
//   const daysPassed = dateDiffInDays(lastTimestamp, timestamp);

//   if (daysPassed <= 0) return;
//   let dataToAbandon = [];
//   for (let i = 1; i <= daysPassed; i++) {
//     dataToAbandon.push(StringifySingleStati(newStati.shift(), (lastTimestamp.getTime() + ((i - 7) * _MS_PER_DAY))))
//     newStati.push({
//       Fajr: 'n',
//       Zuhr: 'n',
//       Asr: 'n',
//       Maghrib: 'n',
//       Isha: 'n',
//       timestamp: new Date(lastTimestamp.getTime() + (i * _MS_PER_DAY)).toISOString()
//     });
//   }

//   const abandonedStati = store.get('abandonedStati') || [];
//   store.set('abandonedStati', [...abandonedStati, ...dataToAbandon]);
//   dispatch({ type: "SYNC_STATI_DATE", payload: { stati: newStati } });
//   store.set('stati', newStati);
// }

// export const editPrayerStatus = (dispatch, stati, newStatus, dayIndex = stati.length - 1) => {
//   const newStati = [...stati];
//   console.log(newStatus);
//   newStati[dayIndex] = { ...newStati[dayIndex], ...newStatus }
//   dispatch({ type: "EDIT_PRAYER_STATUS", payload: { stati: newStati } });
//   store.set('stati', newStati);
// }


export const syncStatiDate = (dispatch, stati, user) => {
  const newStati = [];
  const timestamp = new Date();
  const lastTimestamp = new Date(stati[stati.length - 1].timestamp || stati[stati.length - 1].date);
  const daysPassed = dateDiffInDays(lastTimestamp, timestamp);

  if (daysPassed <= 0) return;
  for (let i = 1; i <= daysPassed; i++) {
    const date = new Date(lastTimestamp.getTime() + (i * _MS_PER_DAY)).toISOString();
    newStati.push({
      Fajr: 'n',
      Zuhr: 'n',
      Asr: 'n',
      Maghrib: 'n',
      Isha: 'n',
      timestamp: date,
      unixTimestamp: new Date(date).getTime()
    });
  }
  const batch = fire.firestore().batch();
  const userRef = fire.firestore().collection('users').doc(user.uid);
  newStati.forEach(doc => {
    batch.set(userRef.collection('stati').doc(new Date(doc.unixTimestamp).toDateString()), doc);
  });
  batch.commit();
}

export const editPrayerStatus = (user, uid, key, value) => {
  fire.firestore().collection('users').doc(user.uid).collection('stati').doc(uid).update({ [key]: value });
}

export const editPreferences = (dispatch, preferences, user) => {
  // dispatch({ type: "EDIT_PREFERENCES", payload: { preferences: { ...preferences } } });
  // store.set("preferences", preferences);
  fire.firestore().collection('users').doc(user.uid).update({ preferences: { ...preferences } });
}

export const setTimings = (dispatch, timings) => {
  timings.Zuhr = timings.Dhuhr;
  dispatch({ type: "SET_TIMINGS", payload: { timings } });
  store.set("timings", timings);
}